import { render, staticRenderFns } from "./invoiceDetail.vue?vue&type=template&id=33c68098&scoped=true"
import script from "./invoiceDetail.vue?vue&type=script&lang=js"
export * from "./invoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./invoiceDetail.vue?vue&type=style&index=0&id=33c68098&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c68098",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c68098')) {
      api.createRecord('33c68098', component.options)
    } else {
      api.reload('33c68098', component.options)
    }
    module.hot.accept("./invoiceDetail.vue?vue&type=template&id=33c68098&scoped=true", function () {
      api.rerender('33c68098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceManage/customerManage/invoiceRecord/invoiceDetail.vue"
export default component.exports